/**
 * UUID v4 для X-Request-Id header'a — cheap request-id (см. контракт
 * логирования §4, согласовано 15.06.2026 с B).
 *
 * Cheap-вариант: фронт генерит UUID, B читает из header (req.id) и пишет
 * в свои логи. При ошибке фронт кладёт тот же UUID в trackError.requestId.
 * SQL-сшивка по UUID работает по двум-трём source'ам через UNION ALL.
 *
 * Fallback на Math.random+Date.now — для старых браузеров без crypto.randomUUID.
 */
export function genRequestId(): string {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  } catch {}
  return (
    Math.random().toString(36).slice(2) +
    Date.now().toString(36) +
    Math.random().toString(36).slice(2)
  )
}
